import Head from "next/head";
import { buildBrandPageTitle, useBrandMetaDescription, useBrandProductName } from "@Front/Stores/hooks/useBrandingSiteTexts";

type BrandHeadProps = {
	pageTitle?: string;
	description?: string;
};

function normalizeOptionalText(value: string | undefined): string | null {
	const s = typeof value === "string" ? value.trim() : "";
	return s.length > 0 ? s : null;
}

export default function BrandHead(props: BrandHeadProps): React.JSX.Element {
	const { pageTitle, description } = props;
	const productName = useBrandProductName();
	const defaultDescription = useBrandMetaDescription();

	const baseTitle = normalizeOptionalText(pageTitle);
	const documentTitle = baseTitle ? buildBrandPageTitle(baseTitle, productName) : productName;

	const overrideDescription = normalizeOptionalText(description);
	const effectiveDescription = overrideDescription ?? defaultDescription;

	return (
		<Head>
			<title>{documentTitle}</title>
			<meta name="description" content={effectiveDescription} key="description" />

			<meta property="og:type" content="website" key="og:type" />
			<meta property="og:site_name" content={productName} key="og:site_name" />
			<meta property="og:title" content={documentTitle} key="og:title" />
			<meta property="og:description" content={effectiveDescription} key="og:description" />

			<meta name="twitter:card" content="summary" key="twitter:card" />
			<meta name="twitter:title" content={documentTitle} key="twitter:title" />
			<meta name="twitter:description" content={effectiveDescription} key="twitter:description" />
		</Head>
	);
}

